<script lang="ts">
  // empowered admin console. Google sign-in → admin allowlist → the Shell. The real
  // boundary is server-side (adminApi verifies the token + admin email on every op)
  // and in firestore.rules; this client gate is UX.
  import { authUser, signOutUser, isAdminEmail } from './lib/firebase';
  import Login from './views/Login.svelte';
  import Shell from './views/Shell.svelte';

  const admin = $derived(isAdminEmail($authUser?.email));
</script>

{#if !$authUser}
  <Login />
{:else if !admin}
  <div class="denied">
    <div class="dcard">
      <span class="beta">Restricted</span>
      <h1>Not authorized</h1>
      <p>You're signed in as <strong>{$authUser.email}</strong>, which isn't an administrator account for this console.</p>
      <button class="out" onclick={() => signOutUser()}>Sign out</button>
    </div>
  </div>
{:else}
  <Shell />
{/if}

<style>
  .denied { min-height: 100dvh; display: grid; place-items: center; padding: var(--space-6); background: radial-gradient(120% 80% at 50% -10%, var(--surface) 0%, var(--bg) 60%); }
  .dcard { width: min(100%, 440px); display: flex; flex-direction: column; align-items: center; text-align: center; gap: var(--space-3); padding: var(--space-8); background: var(--surface); border: 1px solid var(--line); border-radius: var(--radius-lg); }
  .beta { font-size: var(--fs-foot); font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; color: var(--danger); background: var(--danger-soft); border: 1px solid color-mix(in srgb, var(--danger) 40%, transparent); border-radius: var(--radius-pill); padding: 2px 8px; }
  h1 { font-size: var(--fs-heading); font-weight: var(--fw-heading); letter-spacing: -0.02em; }
  p { color: var(--text-2); }
  .out { margin-top: var(--space-2); padding: var(--space-3) var(--space-5); border-radius: var(--radius-pill); background: var(--surface-2); border: 1px solid var(--line-strong); color: var(--text); font-weight: 700; font-size: var(--fs-body); }
  .out:hover { border-color: var(--accent); color: var(--accent); }
</style>
